async function addToCart() {
  const previewContainer = document.querySelector('#custom-text-preview');
  const loader = document.getElementById('loader');
  loader.classList.remove('hidden');
  document.body.style.overflow = 'hidden';
  window.scrollTo({ top: 0, behavior: 'smooth' });

  await new Promise(resolve => setTimeout(resolve, 2000));

  const wrapperDiv = document.createElement("div");
  Object.assign(wrapperDiv.style, {
    position: "absolute",
    top: "-9999px",
    left: "-9999px",
    height: "700px",
    width: "700px",
    backgroundColor: "black",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  });

  const clonedPreview = previewContainer.cloneNode(true);
  Object.assign(clonedPreview.style, {
    marginLeft: "0px",
    marginRight: "0px",
    paddingLeft: "0px",
    paddingRight: "0px",
  });

  wrapperDiv.appendChild(clonedPreview);
  document.body.appendChild(wrapperDiv);

  try {
    // 1️⃣ Capture preview image
    const canvas = await html2canvas(wrapperDiv);
    const imgData = canvas.toDataURL("image/png");

    const sizeText = document
      .getElementById('size-display')
      .textContent.replace('Size: ', '');

    // 2️⃣ Get price directly from page
    // 👉 Change the selector below to match your actual price element
    const displayedPrice = document.querySelector('#price-display, .total-price, .final-price')?.textContent || "0";
    const cleanPrice = Number(displayedPrice.replace(/[^0-9.]/g, "") || 0).toFixed(2);

    console.log("🟢 Sending price to backend:", cleanPrice);

    // 3️⃣ Send to backend PHP to create product
    const backendResponse = await fetch("https://mmstraders.ae/neon-product.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        title: neonObject.previewText,
        imgData: imgData,
        price: cleanPrice, // ✅ Send exact page price
      }),
    });

    if (!backendResponse.ok) {
      throw new Error("Backend request failed");
    }

    const productData = await backendResponse.json();

    if (!productData.success) {
      throw new Error("Product creation failed");
    }

   const finalVariantId = Number(productData.variantId);

console.log("🟢 Raw Variant ID from backend:", productData.variantId);
console.log("🟢 Parsed Variant ID:", finalVariantId);
console.log("🟢 Type:", typeof finalVariantId);

// Shopify indexing delay fix
await new Promise(resolve => setTimeout(resolve, 1500));


    // 4️⃣ Add to Shopify cart
    const cartResponse = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [
          {
            id: finalVariantId,
            quantity: 1,
            properties: {
              'Font': neonObject.font,
              'Color': neonObject.color.name,
              'Size': sizeText,
              'Backboard': neonObject.backboardType,
              'Extra Shipping': "$" + neonObject.shipping,
              'Custom Text': neonObject.previewText,
              'Price': "$" + cleanPrice,
            },
          },
        ],
      }),
    });

    if (!cartResponse.ok) {
      const errText = await cartResponse.text();
      console.error("Cart add failed:", errText);
      throw new Error("Failed to add item to cart");
    }

    // 5️⃣ Redirect to cart
    loader.classList.add('hidden');
    window.location.href = '/cart';

  } catch (error) {
    console.error("Add to Cart Error:", error);
    loader.classList.add('hidden');
    alert("Something went wrong while adding to cart.");
  } finally {
    document.body.removeChild(wrapperDiv);
  }
}
